import { Lazyload } from 'vant'
import { Component, Vue } from 'vue-property-decorator'
import VueTrack from 'vue-track-ve'
import * as components from './component'
import * as prototypes from './prototype'
import * as filter from './filter'

Vue.use(Lazyload)
Vue.use(VueTrack)
Component.registerHooks(['$track'])
Vue.use(components)
Vue.use(prototypes)
Vue.use(filter)
